export const CONSONANT_VOWEL_PAIRS_KK = [

    // ㄲ
    {
        id: 1,
        korean: "까",
        english: "kka",

    },
    {
        id: 2,
        korean: "께",
        english: "kke",

    },
    {
        id: 3,
        korean: "끼",
        english: "kki",

    },
    {
        id: 4,
        korean: "꼬",
        english: "kko",

    },
    {
        id: 5,
        korean: "끄",
        english: "kkeu",

    },
    {
        id: 6,
        korean: "꺼",
        english: "kkeo",

    },
    {
        id: 7,
        korean: "꺄",
        english: "kkya",

    },
    {
        id: 8,
        korean: "깨",
        english: "kkae",

    },
    {
        id: 9,
        korean: "꼐",
        english: "kkye",

    },
    {
        id: 10,
        korean: "꾜",
        english: "kkyo",

    },
    {
        id: 11,
        korean: "껴",
        english: "kkyeo",

    },
    {
        id: 12,
        korean: "뀨",
        english: "kkyu",

    },

    {
        id: 13,
        korean: "깐",
        english: "kkan", 

    },
    {
        id: 14,
        korean: "끽",
        english: "kkik",

        

    },
    {
        id: 15,
        korean: "낌",
        english: "kkim",
        

    },
    {
        id: 16,
        korean: "깟",
        english: "kkat",
        

    },
    {
        id: 17,
        korean: "깧",
        english: "kkah",
        

    },
    {
        id: 18,
        korean: "껍",
        english: "kkeob",
        

    },
          {
        id: 19,
        korean: "끌",
        english: "kkeul",
        

    },
    {
        id: 20,
        korean: "깥",
        english: "kkat",
        

    },
    {
        id: 21,
        korean: "깪",
        english: "kkaekk",
        

    },
    {
        id: 22,
        korean: "깬",
        english: "kkaen",
        

    },
    {
        id: 23,
        korean: "끠",
        english: "kkui",
        

    },
    {
        id: 24,
        korean: "끔",
        english: "kkum",
        

    },

    {
        id: 25,
        korean: "꺝",
        english: "kkyat",
        

    },
    {
        id: 26,
        korean: "깥",
        english: "kkat",
        

    },
    {
        id: 27,
        korean: "깡",
        english: "kkang",
        
    },
    {
        id: 28,
        korean: "깔",
        english: "kkal",
        
    },
    {
        id: 29,
        korean: "껄",
        english: "kkyeol",
        
    },
    {
        id: 30,
        korean: "얶",
        english: "eokk",
        
    },
    {
        id: 31,
        korean: "껗",
        english: "kkeoh",
        
    },
    {
        id: 32,
        korean: "끌",
        english: "kkeul",
        
    },
    {
        id: 33,
        korean: "꿔",
        english: "kkwo",
        
    },
        {
        id: 34,
        korean: "끂",
        english: "kkyup",
        
    },
        {
        id: 35,
        korean: "깔",
        english: "kkal",
        
    }

    
];

